import * as ReactI18n from 'react-i18next';

export const withTranslate = (module = withTranslate.MAIN, options = withTranslate.defaultOptions) => (
  ReactI18n.translate([module], options)
);

withTranslate.defaultOptions = {
  withRef: false,
  wait: true
};

withTranslate.MAIN = 'main';
withTranslate.ADMIN = 'admin';
withTranslate.RA = 'ra';
withTranslate.INSPECTION_COACH = 'inspectionCoach';
withTranslate.IMPROVEMENT_HUB = 'inspectionCentre';
withTranslate.BUILD_A_PROFILE = '2bap';
